import { ofType } from 'redux-observable';
import { mergeMap, map, filter } from 'rxjs';
import type { AppEpic } from 'src/store.types';
import { of } from 'rxjs';
import { updateGroupBy, receiveViewDefns } from 'src/components/Subheader/Subheader.slice';
import { getGroupBy } from 'src/components/Subheader/Subheader.selectors';
import { AssortmentAddSlice, fetchAssortmentAddData, fetchAssortmentAddBySearchData } from './AssortmentAdd.slice';
import {
  inputIsNotNullOrUndefined,
  isScopeDefined,
  isSubheaderLoaded,
  maybeGetComponentProps,
} from 'src/utils/Functions/epicsFunctions';
import {
  ConfDefnComponentType,
  AssortmentAddViewComponent,
  AssortmentAddBySearchComponent,
} from 'configuration-schemas/confdefnComponents';
import { DataApi } from 'configuration-schemas/confdefnView';
import {
  getAggBys,
  ExtraPivotOptions,
  organizeListDataOptions,
} from 'src/pages/Hindsighting/StyleColorReview/StyleColorReview.slice';
import { LEVEL_STYLE_COLOR } from 'src/utils/Domain/Constants';
import { Lens } from 'monocle-ts';
import { makeCartService } from '../../AssortmentCart/AssortmentCart.service';
import { assortmentAddStylesLens } from 'src/services/lenses/lenses';
import { update } from 'src/services/lenses/Lenses.actions';
import { receiveScopeRefreshTrigger } from 'src/components/AssortmentScopeSelector/AssortmentScopeSelector.slice';
import { receiveFilterStateAfterSubmission } from 'src/components/FilterPanel/FilterPanel.slice';
import { setActivePage, setActiveSubPage } from 'src/pages/NavigationShell/NavigationShell.slice';
import { getWeeksFitView } from './AssortmentAddView.utils';
import { LENS_ASST_PLAN_REFRESHING_PAGE } from '../Planning.types';

const selectionService = makeCartService(
  assortmentAddStylesLens.compose(Lens.fromProp<AssortmentAddSlice>()('selectedItemsForCart')),
);

export const assortmentAddLoad: AppEpic = (action$, state$) => {
  return action$.pipe(
    ofType(
      receiveScopeRefreshTrigger.type,
      receiveFilterStateAfterSubmission.type,
      setActivePage.type,
      setActiveSubPage.type,
      updateGroupBy.type,
      receiveViewDefns.type,
      'LENS_ASST_ADD_ASST_CHANGED',
      'LENS_ASST_ADD_WEEKS_CHANGED',
      LENS_ASST_PLAN_REFRESHING_PAGE,
    ),
    map(() =>
      maybeGetComponentProps<AssortmentAddViewComponent>(state$.value, ConfDefnComponentType.assortmentAddView),
    ),
    filter(inputIsNotNullOrUndefined),
    filter(() => isScopeDefined(state$.value.scope) && isSubheaderLoaded(state$.value.subheader)),
    mergeMap(({ defns }) => {
      const { scopeRange, assortmentRange, modelDefn } = state$.value.pages.assortmentBuild.addStyles;
      const finalModelDefn = modelDefn ?? defns.model;

      const dataApi: DataApi = {
        defnId: finalModelDefn,
        isListData: true,
        params: {
          aggBy: LEVEL_STYLE_COLOR,
        },
      };
      const aggBy = getAggBys(getGroupBy(state$.value), dataApi);
      const rangeData = getWeeksFitView(scopeRange, assortmentRange);
      const options: ExtraPivotOptions = { aggBy, ...rangeData };
      const finalOptions = organizeListDataOptions(options, dataApi);

      return of(fetchAssortmentAddData(finalModelDefn, finalOptions), update(selectionService.removeAllItemsFromCart));
    }),
  );
};

export const assortmentAddSearch: AppEpic = (action$, state$) => {
  return action$.pipe(
    ofType(
      receiveScopeRefreshTrigger.type,
      // requestSearchData.type // <- FIXME: adding this causes infinite loop on this handler
    ),
    map(() =>
      maybeGetComponentProps<AssortmentAddBySearchComponent>(state$.value, ConfDefnComponentType.assortmentAddBySearch),
    ),
    filter(inputIsNotNullOrUndefined),
    mergeMap(() => {
      return of(fetchAssortmentAddBySearchData([]));
      // return of(fetchAssortmentAddBySearchData(finalModelDefn, finalOptions));
    }),
  );
};
